<template>
      <v-img
      class="align-end text-white w-100"
      :height="400"
      :src="require(`@/assets/images/about.png`)"
      cover
      lazy 
    ></v-img>
    <v-container>
      <v-row class="flex-child text-subtitle-2 pa-10">
        <v-col
          class="d-flex"
          cols="12"
          lg="6"
          sm="6"
          md="6"
        >
          <v-row class="ma-n3">
            <v-col cols="6">
                <v-img
                  class="align-end text-white w-100"
                  height="250"          
                  :src="require(`@/assets/images/company/socio.jpg`)"
                  cover
                  lazy
              ></v-img>
            </v-col>

            <v-col cols="6">
                <v-img
                  class="align-end text-white w-100"
                  height="250"
                  :src="require(`@/assets/images/company/2151038704.jpg`)"
                  cover
                  lazy
                ></v-img>
            </v-col>

            <v-col cols="12">
                <v-img
                  class="align-end text-white w-100"
                  height="250"
                  :src="require(`@/assets/images/company/middle-aged-hispanic-business-person.jpg`)"
                  cover
                  lazy 
                ></v-img>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12" lg="6" sm="6" md="6">
          <v-sheet
            class="d-flex align-center justify-center flex-wrap text-start mx-auto px-4"
            elevation="0"
            height="600"
            width="100%"
          >
            <div>
              <h2 class="text-h4 font-weight-black text-primary">A Enge BIO NORDESTE</h2>
              <div class="text-h5 font-weight-medium mb-2">
                Política da Qualidade
              </div>

              <p class="text-body-1 mb-4">
                A Direção do Laboratório de Calibração da
                Enge BIO Nordeste se compromete com as
                boas práticas profissionais e a qualidade de
                suas calibrações que estão de acordo com o
                que estabelece a Norma ABNT NBR ISO/IEC
                17025, sendo os serviços prestados de alta
                qualidade e de acordo com um sistema de
                gestão que busca a melhoria contínua de
                sua eficácia, através do envolvimento e
                constante treinamento de sua equipe.
              </p>
            </div>
          </v-sheet>
        </v-col>
    </v-row>
    </v-container>
    <v-row class="bg-primary">
      <v-col cols="12" lg="5" class="d-flex pa-5 align-center">
          <div class="text-h5 font-weight-medium ma-6"  height="600px">
              <h2 class="text-h5 font-weight-black mb-4">Sobre Engebio?</h2>
                Iniciou sua atuação com pequenas consultorias
                em clínicas e Laboratórios da RM com foco
                inicial de projetos de ampliação e adequação às
                RDC's já existentes.
                Em 2010, inaugurou o 1º laboratório de
                calibração (pressão).
                <br/>
                <br/>
                Tornar-se referência em todo território nacional
                como empresa de engenharias especializadas, com
                foco na prestação de serviços de engenharia clínica
                e de metrologia, ambos, com o atendimento de
                normas de qualidade nacionais e internacionais.
            <div class="mt-5">
            </div>
          </div>
        </v-col>
        <v-col cols="12" lg="7" class="pa-0">
          <v-container>
            <v-row class="flex-child text-subtitle-2 pa-5 d-flex align-center justify-center">
              <v-col cols="6">
                      <v-img
                      class="align-end text-white w-100"
                      :src="require(`@/assets/images/company/close-up-hands-working-project.jpg`)"
                      cover
                      height="300"
                      rounded
                    ></v-img>
                  </v-col>
              <v-col
                class="d-flex"
                cols="12"
              >
                <v-row class="ma-n3 d-flex align-center justify-space-between">
                  <v-col cols="5">
                    <v-img
                      class="align-end text-white w-100"
                      :src="require(`@/assets/images/company/male-electrician-works-switchboard-with-electrical-connecting-cable.jpg`)"
                      cover
                      rounded
                      height="400"
                    ></v-img>
                  </v-col>

                  <v-col cols="5">
                      <v-img
                        class="align-end text-white w-100"
                        :src="require(`@/assets/images/company/man-electrical-technician-working-switchboard-with-fuses-uses-tablet.jpg`)"
                        cover
                        height="400"
                        rounded
                      ></v-img>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-container> 
        </v-col>
      </v-row>
      <v-container>
          <v-sheet
              class="d-flex align-center justify-center flex-wrap text-center mx-auto px-4"
              elevation="0"
              height="400"
              width="100%"
              >
              <div>
                <h2 class="text-h4 font-weight-black text-primary">A Enge BIO NORDESTE</h2>
                
                <p class="text-body-1 mt-4">
                  A empresa, com seu DNA inovador, se dedica a criar soluções, sempre melhorando os serviços ofertados e tornando a gestão das companhias de calibrações e engenharia clínica mais eficientes.
                  Agora você conhece um pouco da nossa história. Muito prazer, somos a Enge BIO NORDESTE.

                  TECNOLOGIA é nosso DNA. CALIBRAÇÕES E ENGENHARIA CLÍNICA são nossa VIDA
                </p>
              </div>
            </v-sheet>
      </v-container>
  </template>
<script>
export default {
    name:'AboutView'
}
</script>